// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__tYe1F","content":"LoadingAlert_content__1jowW"};